import { lastAction } from '@owl-nest/utils/'

import * as like from './base'

export async function applyLastActionLike() {
  const action = lastAction.get()

  if (!action) {
    return
  }

  if (action.action === 'like') {
    const response = await like.like(action.id)
    lastAction.remove()

    return response
  }
}
